// SPDX-License-Identifier: MIT
// Launch gate for the deploy_frontend feature (sub-project B chantier 1).
// OFF at launch (opt-in flip, never a global default) — when off, the mise-en-ligne
// wizard keeps its "activer la base" framing and online-preview stays "bientôt"; the
// new "Mettre en ligne mon appli" deploy flow is dormant. Flip to true (VITE_DEPLOY_
// FRONTEND_ENABLED=true) once gen-deployer is live in migration-VPS-OVH.
export function deployFrontendEnabled(): boolean {
  return import.meta.env?.VITE_DEPLOY_FRONTEND_ENABLED === 'true';
}
